<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-row align="center" justify="center" style="height: 300px;">
                    <v-icon class="ghost">mdi-ninja</v-icon>                    
                </v-row>
                <v-row align="center" justify="center">
                    <span class="number">401</span>
                    <span class="text">&nbsp;- {{title}}</span>
                </v-row>                
                <v-row align="center" justify="center" class="other-text">
                    {{text}}
                </v-row>                                
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default{
    computed: {  
        title () {
            return this.$t("Common.access-denied");
        },   
        text () {
            return this.$t("Common.access-denied-description");
        },           
    },   
}
</script>

<style lang="scss" scoped>
    @import "../../styles/material-dashboard/variables";
    .ghost{
        font-size: 150px;
        font-weight: bold;
        color: $brand-primary;
    }    
    .number{
        font-size: 50px;
        font-weight: bold;
        color: $brand-primary;
    }
    .text{
        font-size: 35px;
        font-weight: bold;
        color: $brand-primary;
        text-transform: uppercase;
    }    
    .other-text{
        text-align: center;
        font-size: 20px;
    }      
</style>
